import { boolean, number, object, string } from 'yup';

import { ConverterLTE } from '@utils/frequencyConverters/earfcnConverter';
import { ConverterT5G } from '@utils/frequencyConverters/nrarfcnConverter';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_10_LENGTH, MAX_70_LENGTH } from '@constants/validationMessages';

export const baseSchema = object({
	cellId: string()
		.default('')
		.required(validationErrMessages.cellId)
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Cell ID', MAX_10_LENGTH)),
	band: object()
		.nullable()
		.required(validationErrMessages.band),
	antennaModel: object()
		.shape({
			value: string()
				.max(MAX_70_LENGTH, getMaxLengthErrMsg('Antenna Model', MAX_70_LENGTH))
				.nullable()
				.required(validationErrMessages.antennaModel),
		})
		.nullable()
		.required(validationErrMessages.antennaModel),
	name: string()
		.trim()
		.default('')
		.max(MAX_70_LENGTH, getMaxLengthErrMsg('Cell Name', MAX_70_LENGTH)),
	height: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Height', MAX_10_LENGTH)),
	mechanicalTilt: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Mechanical Tilt', MAX_10_LENGTH)),
	electricalTilt: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Electrical Tilt', MAX_10_LENGTH)),
	azimuth: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Azimuth', MAX_10_LENGTH)),
	totalTilt: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Total Tilt', MAX_10_LENGTH)),
	tac: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('TAC', MAX_10_LENGTH)),
	pci: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('PCI', MAX_10_LENGTH)),
	mechanicalTiltBracketMount: string()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Mechanical Tilt Bracket', MAX_10_LENGTH)),
	mechanicalTiltBracket: boolean().nullable(),
	spinningRange: string()
		.trim()
		.default('')
		.max(MAX_70_LENGTH, getMaxLengthErrMsg('Spinning Range', MAX_70_LENGTH)),
	zone: object()
		.shape({
			value: string()
				.max(MAX_70_LENGTH, getMaxLengthErrMsg('Zone', MAX_70_LENGTH))
				.nullable(),
		})
		.nullable(),
});

export const schema5g = object({
	...baseSchema.fields,
	nrarfcn: number()
		.transform((value) => Number.isNaN(value) ? null : value)
		.min(ConverterT5G.NRARFCN_MIN, validationErrMessages.nrarfcnInvalid)
		.max(ConverterT5G.NRARFCN_MAX, validationErrMessages.nrarfcnInvalid)
		.nullable()
		.required(validationErrMessages.nrarfcn),
	frequency: number()
		.transform((value) => Number.isNaN(value) ? null : value)
		.min(ConverterT5G.FREQ_MIN, validationErrMessages.frequencyInvalid)
		.max(ConverterT5G.FREQ_MAX, validationErrMessages.frequencyInvalid)
		.nullable()
		.required(validationErrMessages.frequency),
});

export const schema4g = object({
	...baseSchema.fields,
	earfcn: number()
		.transform((value) => Number.isNaN(value) ? null : value)
		.min(0, validationErrMessages.earfcnInvalid)
		.max(ConverterLTE.MAX_AVAILABLE_EARFCN, validationErrMessages.earfcnInvalid)
		.nullable()
		.required(validationErrMessages.earfcn),
});
